import React, { forwardRef } from 'react';
import classNames from 'classnames';

import './_button-clear.scss'
import './_button-clear.dark-mode.scss'
import PropTypes from 'prop-types';

import { UI_NAME } from '../../../utils/config';

const ButtonClear = forwardRef(
  (props, ref) => {
    const { disabled, onClick } = props;

    return (
      <button
        disabled={disabled}
        onClick={onClick}
        ref={ref}
        className={classNames(`${UI_NAME}__button-clear`)}
      >
        {props.children}
      </button>
    )
  },
)

ButtonClear.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
}

ButtonClear.defaultProps = {
  disabled: false,
}

export default ButtonClear
